// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"language-selector_dropdown__1tuXO"};